import { useState } from "react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { MessageSquare } from "lucide-react";
import CipherSelector from "./components/CipherSelector";
import EncryptionPanel from "./components/EncryptionPanel";
import { TranslationMode } from "./types";

export default function EmCrypter() {
  const [mode, setMode] = useState<TranslationMode>("encrypt");
  const [selectedCipherId, setSelectedCipherId] = useState<string | null>(null);
  const [selectedCipherCode, setSelectedCipherCode] = useState<string | null>(null);

  const handleCipherSelect = (id: string, code: string) => {
    setSelectedCipherId(id);
    setSelectedCipherCode(code);
  };

  return (
    <div className="w-full bg-white rounded-lg shadow-sm border border-purple-100 dark:bg-gray-900 dark:border-purple-800 p-6">
      <h1 className="text-3xl font-bold mb-6 text-primary">
        EM-Crypter
      </h1>

      <div className="grid grid-cols-1 lg:grid-cols-[2fr_3fr] gap-6">
        <div>
          <CipherSelector
            onSelect={handleCipherSelect}
            selectedCipherId={selectedCipherId || ""}
          />
        </div>

        <div>
          <Tabs
            value={mode}
            onValueChange={(value) => setMode(value as TranslationMode)}
            className="w-full"
          >
            <TabsList className="grid w-full grid-cols-2 mb-6">
              <TabsTrigger value="encrypt" className="data-[state=active]:bg-white">
                Emcrypt
              </TabsTrigger>
              <TabsTrigger value="decrypt" className="data-[state=active]:bg-white">
                Decrypt
              </TabsTrigger>
            </TabsList>

            {selectedCipherId && selectedCipherCode ? (
              <EncryptionPanel
                selectedCipherCode={selectedCipherCode}
                mode={mode}
              />
            ) : (
              <div className="w-full h-full flex flex-col items-center justify-center p-8 bg-gray-50 dark:bg-gray-800 rounded-lg border-2 border-dashed border-gray-300 dark:border-gray-600 text-gray-500 dark:text-gray-400 gap-3">
                <MessageSquare className="h-12 w-12 text-gray-300 dark:text-gray-600" />
                <p className="text-lg font-medium">Select a cipher to begin</p>
                <p className="text-sm">Choose a cipher from the list on the left, then encrypt or decrypt your messages.</p>
              </div>
            )}
          </Tabs>
        </div>
      </div>
    </div>
  );
}
